import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from './shared/Text';
import IntroSlides, { calcVideoSize } from './IntroSlides';
import { GOLDEN200, pOrT } from './styleConstants';

import appStore from '../stores/app';

import { t } from '../utils/appUtils';
const DESC_HEIGHT = pOrT(45, 100);
const { videoHeight: VIDEO_HEIGHT, videoWidth: VIDEO_WIDTH } = calcVideoSize({
  descHeight: DESC_HEIGHT,
  offset: pOrT(6, 60) + 20 + 65,
  maxHeight: 800,
});

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
  },
});

function navigateForward() {
  appStore.navigate('Inner', 'outer', 'reset');
}

export default class IntroScreen extends Component {
  render() {
    return (
      <View style={styles.wrapper} testID="introScreen">
        <View
          style={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            marginLeft: -VIDEO_WIDTH / 2,
            marginTop: -(VIDEO_HEIGHT + 100) / 2,
          }}
        >
          <IntroSlides
            videoWidth={VIDEO_WIDTH}
            videoHeight={VIDEO_HEIGHT}
            descHeight={DESC_HEIGHT}
            skipBtnLabel={
              <Text
                bold
                style={{
                  color: GOLDEN200,
                  fontSize: pOrT(14, 16),
                }}
              >
                {t('intro.skipIntro')}
              </Text>
            }
            doneBtnLabel={
              <Text
                bold
                style={{
                  color: GOLDEN200,
                  fontSize: pOrT(14, 16),
                }}
              >
                {t('intro.doneIntro')}
              </Text>
            }
            onSkipBtnClick={navigateForward}
            onDoneBtnClick={navigateForward}
          />
        </View>
      </View>
    );
  }
}
